<template>
  <b-overlay
    opacity="0.50"
    rounded="sm"
  >
    <b-card>
      <div class="text-primary d-flex">
        <feather-icon
          icon="UserIcon"
          size="19"
        />
        <h4 class="mb-0 ml-50 text-primary">
          Información de alumno
        </h4>
      </div>
      <validation-observer ref="simpleRules">
        <b-form class="mt-1">

          <b-row>
            <b-col lg="3">
              <b-input-group>
                <b-input-group-prepend>
                  <b-button variant="outline-primary">
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-prepend>
                <b-form-input
                  v-model="busqueda"
                  placeholder="Introduce la matricula"
                />
                <b-input-group-append>
                  <b-button
                    variant="outline-primary"
                    @click="onSearch(busqueda)"
                  >
                    Buscar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
          <div v-if="alumno.nombre != null">
            <b-row class="m-1">
              <b-col lg="8">
                <strong class="text-primary">Nombre: </strong> <h4> {{ alumno.nombre }} {{ alumno.segundoNombre }} {{ alumno.apellidoPaterno }} {{ alumno.apellidoMaterno }} </h4>
              </b-col>
              <b-col lg="4">
                <strong class="text-primary">Matricula: </strong> <h4> {{ alumno.matricula }}</h4>
              </b-col>
            </b-row>

            <b-row class="m-1">
              <b-col
                lg="12"
                md="12"
              >
                <strong class="text-primary">Kardex: </strong>
              </b-col>
              <b-container
                v-if="kardex.length > 0"
                fluid
              >
                <b-list-group>
                  <span>Calificaciones</span><br>
                  <b-list-group-item
                    v-for="(kardex, index) in kardex"
                    :key="'cursando' + index"
                    class="d-flex justify-content-between align-items-center"
                  >
                    <p>
                      <b-badge
                        variant="warning"
                        pill
                        class="badge-round"
                      >
                        {{ kardex.cal_fin }}
                      </b-badge>
                      <b-badge
                        variant="primary"
                        pill
                        class="badge-round"
                      >
                        {{ kardex.status }}
                      </b-badge>
                      <b-badge
                        variant="secondary"
                        pill
                        class="badge-round"
                      >
                        {{ kardex.periodo_agenda }}
                      </b-badge>
                      <small><b> Nivel {{ kardex.orden }} : </b></small>
                      <small class="text-primary"><b>{{ kardex.nombre_materia }} : </b></small>
                      <small>  {{ kardex.descripcion }}</small>
                    </p>
                    <feather-icon
                      :id="`kardex-row-${index}-editar-icon`"
                      icon="Edit3Icon"
                      class="cursor-pointer mr-1"
                      size="16"
                      @click="infokardexclicked = { 'kardex':kardex, 'alumno': alumno }"
                    />
                    <b-tooltip
                      title="Editar Calificación"
                      :target="`kardex-row-${index}-editar-icon`"
                    />
                  </b-list-group-item>
                </b-list-group>
              </b-container>
            </b-row>
          </div>
        </b-form>
      </validation-observer>
    </b-card>
    <b-card>
      <div class="text-primary d-flex">
        <feather-icon
          icon="DatabaseIcon"
          size="19"
        />
        <h4 class="mb-0 ml-50 text-primary">
          Proceso cambio de calificación fuera de fechas de evaluación
        </h4>
      </div>
      <b-row>
        <b-col>
          <pasoscalificar
            :infokardex="infokardexclicked"
          />
        </b-col>
      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BRow, BCol, BForm,
  BFormInput, BButton, BContainer,
  BOverlay, BCard, BTooltip,
  BInputGroup, BInputGroupAppend, BInputGroupPrepend,
  BListGroup, BListGroupItem, BBadge,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import { getData } from '@core/utils/http/general'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import pasoscalificar from '@/views/campus/extra-functions/calificar/components/pasoscalificar.vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BButton,
    BCard,
    BForm,
    BFormInput,
    BOverlay,
    BTooltip,
    ValidationObserver,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BListGroup,
    BListGroupItem,
    BBadge,
    pasoscalificar,
  },
  data() {
    return {
      busqueda: '',
      required,
    }
  },
  setup() {
    const toast = useToast()
    const alumno = ref([])
    const kardex = ref([])
    const infokardexclicked = ref({})
    const getKardex = search => {
      if (search.length <= 3) return false // SEARCH IT'S EMPTY OR LESS THAN 4 LETTERS
      const paramsRequest = {
        action: 2,
        data: search,
        token: store.state.cuenta.session.token,
      }
      getData(paramsRequest, 'wsadinterna')
        .then(response => {
          if (response.data.status === 200) {
            kardex.value = response.data.data || []
            toast({
              component: ToastificationContent,
              props: {
                title: 'Kardex encontrado',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'success',
              },
            },
            { timeout: 10000 })
            return true
          }
          toast({
            component: ToastificationContent,
            props: {
              title: 'Kardex no encontrado',
              text: response.data.message,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
          return false
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando el kardex',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
      return true
    }
    // * Buscador
    const onSearch = search => {
      infokardexclicked.value = { kardex: undefined, alumno: undefined }
      alumno.value = []
      kardex.value = []
      if (search.length <= 3) return false // SEARCH IT'S EMPTY OR LESS THAN 4 LETTERS
      const paramsRequest = {
        action: 1,
        data: search,
        token: store.state.cuenta.session.token,
      }
      getData(paramsRequest, 'wsadinterna')
        .then(response => {
          if (response.data.status === 200) {
            alumno.value = response.data.data[0] || []
            getKardex(search)
            toast({
              component: ToastificationContent,
              props: {
                title: 'Alumno encontrado',
                text: response.data.message,
                icon: 'AlertCircleIcon',
                variant: 'success',
              },
            },
            { timeout: 10000 })
            return true
          }
          toast({
            component: ToastificationContent,
            props: {
              title: 'Alumno no encontrado',
              text: response.data.message,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
          return false
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error cargando el alumno',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
      return true
    }
    return {
      onSearch,
      alumno,
      kardex,
      getKardex,
      infokardexclicked,
    }
  },
}
</script>
